import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  content: {
    margin: '24px 64px 0 64px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: '16px',
  },
  sectionTitle: {
    color: theme.colors.illustration.oceanGreen,
  },
}));
